export * from './DeviceDetailsPage';
export * from './completedDeviceDetails';
